import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react'
import { Button, Card, Divider } from '@nextui-org/react'
import { FC, useEffect } from 'react'
import { postLive } from '../../api/live/live'
import { useBatchStore } from '../../store/batch/useBatchStore'
import useCustomizeLiveStore from '../../store/live/useCustomizeLiveStore'
import { cameraMapType, videoMapResponseType } from '../../types/apiResponse/liveTypes'
import { ModalText } from '../common/Text'
import { CameraPosition } from './CameraPosition'
import { Icon } from './Icon'
import { SetGrid } from './SetGrid'

export type CustomizeLiveProps = {
  setIsUpdated: () => void
  videoMap: videoMapResponseType | null
}

export const CustomizeLive: FC<CustomizeLiveProps> = ({ setIsUpdated, videoMap }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const batches = useBatchStore((state) => state.batches)
  const groupIds = Object.keys(batches).filter(
    (groupId) => groupId !== '$empty' && groupId !== '$ungrouped',
  )
  const { setVideoMap, saveData } = useCustomizeLiveStore()

  useEffect(() => {
    if (videoMap !== null) {
      setVideoMap(videoMap)
    }
  }, [videoMap, isOpen, setVideoMap])

  const saveCustomizeLive = (onClose: () => void, saveData: cameraMapType | null) => {
    if (saveData) {
      postLive(saveData, setIsUpdated, onClose).then(() => {})
    }
  }

  return (
    <>
      <Button onPress={onOpen} isIconOnly className="bg-backgroud">
        <Icon name="edit" />
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="outside" isCentered>
        <ModalOverlay />
        <ModalContent p={{ base: '20px', md: '40px' }}>
          <ModalHeader
            className="flex flex-col gap-6 pt-12 pl-12 pr-12 font-bold leading-6"
            style={{ fontSize: '2rem' }}
            px={{ base: '4', md: '12' }}
            pt={{ base: '6', md: '12' }}
          >
            Customize Live
            <small className="" style={{ fontSize: '0.9rem', fontWeight: 'normal' }}>
              {ModalText('Customize Live')}
            </small>
          </ModalHeader>
          <ModalBody p={0}>
            <Divider className="my-4" style={{ margin: '1px' }} />
            <div className="hidden md:block">
              <SetGrid />
            </div>
            <div className="mt-4 mb-2" style={{ fontSize: '1rem', fontWeight: 'bold' }}>
              Preview
            </div>
            <Card className="py-4 md:bg-tdplbisque" style={{ padding: '1rem', height: '100%' }}>
              <CameraPosition groupIds={groupIds} />
            </Card>
          </ModalBody>
          <div className="flex justify-end gap-2 pt-4 border-t border-gray-200" style={{ marginLeft: 0 }}>
            <Button
              className="font-bold text-tdplindigo pr-7 pl-7 bg-white border border-tdpldarkgrey border-opacity-60 hover:bg-tdpllightgrey"
              style={{ marginLeft: 0 }}
              onPress={onClose}
            >
              Cancel
            </Button>
            <Button
              className="font-bold text-white pr-7 pl-7 bg-tdplplum"
              style={{ marginLeft: 0 }}
              onPress={() => saveCustomizeLive(onClose, saveData)}
            >
              Save
            </Button>
          </div>
        </ModalContent>
      </Modal>
    </>
  )
}
